import { useEffect, useState } from "react";

interface RuntimeConfig {
  HELP_URL?: string;
  FORECAST_HELP_URL?: string;
  FORMULA_HELP_URL?: string
}

export const useRuntimeConfig = (): RuntimeConfig => {
  const [config, setConfig] = useState<RuntimeConfig>({});

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/config.js";
    script.onload = () => {
      setConfig((window as any).RUNTIME_CONFIG || {});
    };
    script.onerror = () => {
      console.error("Failed to load config.js");
      setConfig({});
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return config;
};
